import PrismTopContent from './prismTopContent'
export default PrismTopContent
